import { apiRequest } from '../api/http'
import type { AuthResponse } from './types'

const base = '/api/auth/google'

export function googleConfig() {
  return apiRequest<{ enabled: boolean; clientId: string }>(base, '/config')
}

// StrictMode can mount effects twice. Share in-flight requests so a late response
// cannot overwrite the browser cookie with a different nonce from the rendered button.
let challengeRequest: Promise<{ nonce: string }> | undefined
export function googleChallenge() {
  challengeRequest ??= apiRequest<{ nonce: string }>(base, '/challenge', { method: 'POST', body: {} })
    .finally(() => { challengeRequest = undefined })
  return challengeRequest
}

export function googleLogin(credential: string) {
  return apiRequest<AuthResponse>(base, '/login', { method: 'POST', body: { credential }, skipSessionRefresh: true })
}

export function googleRegister(credential: string, fullName: string, organizationName: string, locale: 'ar' | 'en') {
  return apiRequest<AuthResponse>(base, '/register', {
    method: 'POST', body: { credential, fullName, organizationName, locale }, skipSessionRefresh: true,
  })
}

export function googleLink(credential: string, currentPassword: string, accessToken: string) {
  return apiRequest<void>(base, '/link', {
    method: 'POST', body: { credential, currentPassword }, accessToken, skipSessionRefresh: true,
  })
}
